import type { Job } from '../../../types';

export const matchesQuery = (job: Job, query: string) => {
  if (!query) {
    return true;
  }

  const text = [
    job.title,
    job.company,
    job.department,
    job.location,
    job.description,
    job.typeOfContract,
    ...job.skills.map((s) => s.name)
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return text.includes(query);
};
